import Vue from 'vue';
import Router from 'vue-router';
import Guard from '@/services/middleware';

import Home from '@/views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: Guard.auth,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "topics" */ '@/views/Login.vue'),
      beforeEnter: Guard.guest,
    },
    {
      path: '/topics',
      name: 'topics',
      component: () => import(/* webpackChunkName: "topics" */ '@/views/Topics.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/topics/:id',
      name: 'topic',
      component: () => import(/* webpackChunkName: "topic" */ '@/views/Topic-Single.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/feeds',
      name: 'feeds',
      component: () => import(/* webpackChunkName: "feeds" */ '@/views/Feeds.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/feeds/new',
      name: 'new-feed',
      component: () => import(/* webpackChunkName: "new-feed" */ '@/views/Feed-New.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/feeds/:id',
      component: () => import(/* webpackChunkName: "feed" */ '@/views/Feed-Single.vue'),
      beforeEnter: Guard.auth,
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "feed-settings" */ '@/views/Feed-Single-Settings.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'fixtures',
          component: () => import(/* webpackChunkName: "feed-fixtures" */ '@/views/Feed-Single-Fixtures.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'fixtures/:fixture_id/view',
          component: () => import(/* webpackChunkName: "feed-fixture" */ '@/views/Fixture.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'fixtures/:status',
          component: () => import(/* webpackChunkName: "feed-fixtures" */ '@/views/Feed-Single-Fixtures.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'articles',
          component: () => import(/* webpackChunkName: "feed-articles" */ '@/views/Feed-Single-Articles.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'videos',
          component: () => import(/* webpackChunkName: "feed-videos" */ '@/views/Feed-Single-Videos.vue'),
          beforeEnter: Guard.auth,
        },
        {
          path: 'logs',
          component: () => import(/* webpackChunkName: "feed-logs" */ '@/views/Feed-Single-Logs.vue'),
          beforeEnter: Guard.auth,
        },
      ],
    },
    {
      path: '/articles',
      name: 'articles',
      component: () => import(/* webpackChunkName: "articles" */ '@/views/Articles.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/articles/reimport',
      name: 'article-reimport',
      component: () => import(/* webpackChunkName: "article-reimport" */ '@/views/Article-Reimport.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/articles/:id',
      name: 'article-single',
      component: () => import(/* webpackChunkName: "article" */ '@/views/Article-Single.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/videos/reimport',
      name: 'video-reimport',
      component: () => import(/* webpackChunkName: "video-reimport" */ '@/views/Video-Reimport.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/videos',
      name: 'videos',
      component: () => import(/* webpackChunkName: "videos" */ '@/views/Videos.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/videos/:id',
      name: 'videos-single',
      component: () => import(/* webpackChunkName: "video" */ '@/views/Video-Single.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools',
      name: 'tools',
      component: () => import(/* webpackChunkName: "tools" */ '@/views/Tools.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/history',
      name: 'history',
      component: () => import(/* webpackChunkName: "history" */ '@/views/History.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/history/:id',
      name: 'history-item',
      component: () => import(/* webpackChunkName: "history-single" */ '@/views/History-Single.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/explorer',
      name: 'explorer',
      component: () => import(/* webpackChunkName: "explorer" */ '@/views/Explorer.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/explorer/spotlight/:sport',
      name: 'explorer-single-spotlight',
      component: () => import(/* webpackChunkName: "explorer-single-spotlight" */ '@/views/Explorer-Spotlight.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/explorer/:category/:slug',
      name: 'explorer-single',
      component: () => import(/* webpackChunkName: "explorer-single" */ '@/views/Explorer-Single.vue'),
      beforeEnter: Guard.auth,
    },{
      path: '/tools/cache',
      name: 'cache',
      component: () => import(/* webpackChunkName: "cache" */ '@/views/Cache.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/weights',
      name: 'weights',
      component: () => import(/* webpackChunkName: "weights" */ '@/views/Weights.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/featured',
      name: 'featured',
      component: () => import(/* webpackChunkName: "featured" */ '@/views/Featured.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/featured/main/:type',
      name: 'featured-main',
      component: () => import(/* webpackChunkName: "featured-main" */ '@/views/Featured-Main.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/featured/sub/:type',
      name: 'featured-sub',
      component: () => import(/* webpackChunkName: "featured-sub" */ '@/views/Featured-Sub.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/featured/apps/:type',
      name: 'featured-apps',
      component: () => import(/* webpackChunkName: "featured-apps" */ '@/views/Featured-Apps.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/tools/rounds',
      name: 'rounds',
      component: () => import(/* webpackChunkName: "rounds" */ '@/views/Rounds.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/pages',
      name: 'pages',
      component: () => import(/* webpackChunkName: "pages" */ '@/views/Pages.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/pages/new',
      name: 'page-new',
      component: () => import(/* webpackChunkName: "page-new" */ '@/views/Page-New.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/pages/:id',
      name: 'page-singe',
      component: () => import(/* webpackChunkName: "page-single" */ '@/views/Page-Single.vue'),
      beforeEnter: Guard.auth,
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ '@/views/Logout.vue'),
      beforeEnter: Guard.auth,
    },
  ],
});
